<div mat-subheader class='cartDetail'>
  <span class='purchaseDate'> {{ item.CheckOutDate | date }} </span>
  <span class='purchaseTotalPrice'> Totale: {{ item.FinalAmount | currency:'EUR':'symbol':'1.0' }}</span>
</div>
